import { useEffect, useState } from 'react'
import DateTimePicker from '../DateTime.jsx'
import 'react-datetime/css/react-datetime.css'
import PropTypes from 'prop-types'
import Validation from '../../wizard/Validation'

const DateTimeWiz = (props) => {
    const dataFieldText =
        props.keyName.substring(props.keyName.lastIndexOf('.') + 1) ||
        props.keyName
    const labelFieldText = props.keyName
        .split('.')
        .map((t) => parseInt(t) || t)
        .filter((i) => isNaN(i))
        .join('.')

    const form = props.name ? props.wiz.form?.[props.name] : props.wiz.form
    const value = props.value
        ? props.value
        : props.row
        ? props.row?.[dataFieldText]
        : form?.[dataFieldText]
    const setter = props.setRow ? props.setRow : props.wiz.setValue

    let inputProps = {
        disabled: props.disabled,
        placeholder: '',
    }

    const [values, setValues] = useState(value)

    useEffect(() => {
        setValues(value)
    }, [value])

    if (props.hide) return null

    return (
        <Validation wiz={props.wiz} field={props.keyName}>
            <DateTimePicker
                keyName={props.keyName}
                label={props.label ?? props.wiz?.getLabel(labelFieldText)}
                tooltipText={props.wiz.getToolTip(
                    props.keyName || labelFieldText || dataFieldText
                )}
                name={props.name}
                hideTime={props.hideTime}
                className={props.className}
                title={props.title}
                readOnly={props.readOnly}
                validDate={props.validDate}
                hideLabel={props.hideLabel}
                pastOnly={props.pastOnly}
                initialViewDate={props.initialViewDate}
                onChange={(date) => {
                    setter(dataFieldText, date)
                    setValues(date)
                }}
                value={values}
                dateFormat={props.dateFormat}
                format={props.format}
                inputProps={inputProps}
            />
        </Validation>
    )
}

DateTimeWiz.propTypes = {
    wiz: PropTypes.any.isRequired,
    keyName: PropTypes.string.isRequired,
    name: PropTypes.string,
    hideTime: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    validDate: PropTypes.func,
    hideLabel: PropTypes.bool,
    pastOnly: PropTypes.bool, // true => ograniczenie zakresu dat: przeszłość -> bieżąca data
    futureOnly: PropTypes.bool,
    initialViewDate: PropTypes.any,
    disabled: PropTypes.bool,
    dateFormat: PropTypes.string,
    value: PropTypes.any,
    setRow: PropTypes.func,
    row: PropTypes.any,
    label: PropTypes.string,
    format: PropTypes.string,
    hide: PropTypes.bool,
}

export default DateTimeWiz
